import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

interface EmptyStateProps {
  onCreateMapping: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ onCreateMapping }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{ py: 6, px: 2, flex: 1 }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 3, textAlign: 'center' }}
      >
        Create a mapping to sync your table columns with CRM fields.
      </Typography>
      <Button
        variant="contained"
        startIcon={<EditIcon />}
        onClick={onCreateMapping}
        sx={(theme) => ({
          border: `1px solid ${theme.customColors?.themePrimary || 'primary.main'}`,
          backgroundColor: theme.customColors?.themePrimary || 'primary.main',
          color: theme.customColors?.themeSecondary || 'white',
          borderRadius: '50px',
          textTransform: 'capitalize',
          px: 4,
          py: 1.5
        })}
      >
        Create Mapping
      </Button>
    </Box>
  );
};

export default EmptyState;
